/** Conservative quality check for internal build directions, not an AI safety filter. */
export function isInternalWebsiteBrief(value: string): boolean {
  const text=value.normalize("NFC").replace(/\s+/g," ");
  return /(?:^|[\s.;])(?:primary|secondary|main|basic|βασικ[όο]|δευτερε[ύυ]ον|κ[ύυ]ριο)\s+CTA\s*:/iu.test(text)
    || /(?:^|[\s.;])(?:CTA|image prompt|system prompt|layout instructions|οδηγ[ίι]ες (?:σχεδιασμο[ύυ]|προς (?:την )?Kate))\s*:/iu.test(text)
    || /(?:^|[\s.;])(?:παρουσ[ίι]ασε κατηγορ[ίι]ες|μην επινοε[ίι]ς|μην εμφαν[ίι]ζεις τιμ[έε]ς|return only (?:JSON|the supplied)|use (?:our|the supplied) widgets|do not invent (?:prices|testimonials|business facts))/iu.test(text);
}

/** Preserve genuine supplied prose; use a factual placeholder for an internal brief. */
export function customerFacingSeed(value: string, fallback: string): string {
  return value && !isInternalWebsiteBrief(value) ? value : fallback;
}
